import { Radio } from '@/components/Radio/Radio'
import './ManageLabelsForContactFloatingMenu.scoped.sass'
// eslint-disable-next-line
export function ManageLabelsForContactFloatingMenu ({ onBlur, contact, labels, event, selectedLabels, onLabelSelected }) {
  const positioningStyle = {
    position: 'absolute',
    left: '70px',
    bottom: '100px',
  }
  // eslint-disable-next-line
  function isOpenedForThisTarget (event) {
    const {
      top,
      left
    } = event.target.getBoundingClientRect()
    return this.isOpen && top === this.coordinates.top && left === this.coordinates.left
  }

  return <div className='manage-labels-container' style={positioningStyle}>
    <div className='top-bar'>
      <div>Manage Labels</div>
      <div className='cursor-pointer' onClick={() => onBlur()}>X</div>
    </div>
    <div className='content'>
      <ul className='label-list'>
        {labels.map((label, index) => {
          return <li className='label' key={index}>
            <Radio
              key={index}
              label={label?.name}
              name={label?.name}
              onChecked={() => { onLabelSelected(label) }}
              checked={selectedLabels?.filter((sl) => sl.composedid === label.composedid).length > 0} /></li>
        })}
      </ul>
    </div>
  </div>
}
